import { render, staticRenderFns } from "./UpdateImportStock.vue?vue&type=template&id=89bb5d14&"
import script from "./UpdateImportStock.vue?vue&type=script&lang=js&"
export * from "./UpdateImportStock.vue?vue&type=script&lang=js&"
import style0 from "./UpdateImportStock.vue?vue&type=style&index=0&id=89bb5d14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports